<template>
  <v-dialog
    v-model="isDialogEdit"
    max-width="400"
    @click:outside="$emit('update:is-dialog-edit',false)" 
  >
    <v-card>
        <v-card-title>Download details</v-card-title>
        <v-card-text>
            <v-row>
                <v-col
                    cols="12"
                    md="4"
                    sm="4"
                    v-for="side, index in sideList"
                    :key="index"
                >
                    <v-checkbox
                        v-model="sides"
                        :label="side.label"
                        :value="side.value"
                        hide-details
                    ></v-checkbox>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                text
                outlined
                class="mr-2"
                @click="$emit('update:is-dialog-edit',false)" 
            >Cancel</v-btn>
            <v-btn
                color="primary"
                outlined
                :loading="loading"
                @click="download"
            >
                
                <v-icon >{{ icons.mdiFileDownloadOutline }}</v-icon>

                PNGs
            </v-btn>
            <v-btn
                color="info"
                outlined
                class="ml-2"
                :loading="loading"
                @click="downloadDecipher"
                v-if="$can('add', 'skutopia')"
            >
                <v-icon >{{ icons.mdiCloudDownloadOutline }}</v-icon>
                Decipher
            </v-btn>
        </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import {
    mdiFileDownloadOutline,
    mdiCloudDownloadOutline
} from '@mdi/js';

export default {
    props: {
        isDialogEdit: {
            type: Boolean,
            required:true
        },  
        loading: {
            type: Boolean,
            required:true
        }
    },
    setup(props, { emit }) {

        const sides = ref([])
        const sideList = ref([
            {value: '1', label: 'Front'},
            {value: '2', label: 'Back'},
            {value: '3', label: 'Top'},
            {value: '4', label: 'Bottom'},
            {value: '5', label: 'Left'},
            {value: '6', label: 'Left 45°'},
            {value: '7', label: 'Left 135°'},
            {value: '8', label: 'Right'},
            {value: '9', label: 'Right 45°'},
            {value: '10', label: 'Right 135°'},
            {value: '11', label: 'Detail'},
            {value: '12', label: 'Other'},
        ])

        const download = () => {
            const sidesPayload = JSON.parse(JSON.stringify(sides.value))
            emit('download', sidesPayload)
        }
        
        const downloadDecipher = () => {
            const sidesPayload = JSON.parse(JSON.stringify(sides.value))
            emit('download-decipher', sidesPayload)
        }
        

        return {
            sides,
            sideList,

            download,
            downloadDecipher,
            icons: {
                mdiFileDownloadOutline,
                mdiCloudDownloadOutline
            }
        }
    }

}
</script>

<style>

</style>